import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N20A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CenterLayout = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: "var(--ds-space-250, 20px)".concat(" 0px ", "var(--ds-space-500, 40px)", " 0px")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NoNotificationsTextContainer = styled.div({
  marginTop: "var(--ds-space-200, 16px)",
  maxWidth: '225px',
  textAlign: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NoUnreadNotificationsButtonContainer = styled.div({
  marginTop: "var(--ds-space-200, 16px)"
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NoNotificationsSkeleton = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 198px;\n\theight: 198px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\tmargin-top: ", ";\n\tposition: relative;\n\toverflow: hidden;\n\t&::after {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\ttransform: translateX(-100%);\n\t\tbackground-image: linear-gradient(\n\t\t\t90deg,\n\t\t\t", " 0%,\n\t\t\t", " 50%,\n\t\t\t", " 100%\n\t\t);\n\t\t", "\n\t\tcontent: '';\n\t\tz-index: 10;\n\t}\n\n\t@keyframes shimmer {\n\t\t100% {\n\t\t\ttransform: translateX(100%);\n\t\t}\n\t}\n"])), "var(--ds-background-neutral, ".concat(N20A, ")"), "var(--ds-space-500, 40px)", "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))", "var(--ds-background-neutral-hovered, rgba(255, 255, 255, 0.2))", "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))", function (p) {
  return p.noAnimation ? '' : 'animation: shimmer 5s infinite;';
});